<template>
  <div class="main">
    <router-view
      v-wechat-title="msg ? msg : '一石数字官网-让智能守护美好生活'"
    />
  </div>
</template>

<script>
export default {
  name: "Appmain",
  data() {
    return {
      msg: "",
    };
  },
  watch: {
    $route(to, from) {
      this.msg = "";
      this.$nextTick(() => {
        this.msg = to.meta.name;
      });
    },
  },

  created() {
    this.msg = "";
    this.$nextTick(() => {
      this.msg = this.$route.meta.name;
    });
  },
};
</script>

<style scoped>
@media screen and (max-width: 769px) {
  .main {
    margin-top: 0.88rem;
  }
}
</style>
